import { render, staticRenderFns } from "./TnyFishSelectModal.vue?vue&type=template&id=a865cc1e&"
import script from "./TnyFishSelectModal.vue?vue&type=script&lang=ts&"
export * from "./TnyFishSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports